(function () {
  function localizedRoot() {
    var candidate =
      window.ShopponiTheme && typeof window.ShopponiTheme.rootUrl === 'string'
        ? window.ShopponiTheme.rootUrl
        : '/';

    if (!candidate || candidate === '/') return '/';
    return candidate.endsWith('/') ? candidate : candidate + '/';
  }

  function localizedPath(path) {
    var root = localizedRoot();
    var cleanPath = String(path || '').replace(/^\/+/, '');
    return root + cleanPath;
  }

  function localizeInternalLinks() {
    var root = localizedRoot();
    if (root === '/') return;

    var prefix = root.slice(0, -1);
    var selector = [
      '.shopponi-tcg-page a[href^="/"]',
      '.se a[href^="/"]',
      '.shopponi-info-page a[href^="/"]',
      '.sp a[href^="/"]'
    ].join(',');

    document.querySelectorAll(selector).forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href || href === '/' || href.indexOf('//') === 0 || href.charAt(0) !== '/') return;
      if (href === prefix || href.indexOf(prefix + '/') === 0) return;

      link.setAttribute('href', prefix + href);
    });
  }

  var strings = {
    it: { home: 'Home', account: 'Account', wishlist: 'Wishlist', cart: 'Carrello', menubar: 'Menubar' },
    en: { home: 'Home', account: 'Account', wishlist: 'Wishlist', cart: 'Cart', menubar: 'Menu bar' },
    fr: { home: 'Accueil', account: 'Compte', wishlist: 'Favoris', cart: 'Panier', menubar: 'Barre de navigation' },
    de: { home: 'Startseite', account: 'Konto', wishlist: 'Wunschliste', cart: 'Warenkorb', menubar: 'Navigationsleiste' },
    es: { home: 'Inicio', account: 'Cuenta', wishlist: 'Favoritos', cart: 'Carrito', menubar: 'Barra de navegación' }
  };

  function localeCode() {
    var lang = document.documentElement.getAttribute('lang') || 'it';
    lang = lang.toLowerCase().split('-')[0];
    return strings[lang] ? lang : 'it';
  }

  function replaceTitle(element, oldValue, newValue) {
    if (!element) return;
    var title = element.getAttribute('title');
    if (title && title.trim() === oldValue) {
      element.setAttribute('title', newValue);
    }
  }

  function translateToolbar() {
    var locale = localeCode();
    var copy = strings[locale] || strings.it;
    var toolbar = document.querySelector('.scoder-toolbar-mobile');
    if (!toolbar) return;

    toolbar.setAttribute('aria-label', copy.menubar);

    var home = toolbar.querySelector('[data-toolbar-home] .toolbar-label');
    if (home) home.textContent = copy.home;

    var accountLink = toolbar.querySelector('[data-toolbar-account]');
    var account = accountLink && accountLink.querySelector('.toolbar-label');
    if (account) account.textContent = copy.account;
    replaceTitle(accountLink, 'Account', copy.account);

    var wishlistLink = toolbar.querySelector('[data-toolbar-wishlist]');
    var wishlist = wishlistLink && wishlistLink.querySelector('.toolbar-label');
    if (wishlist) wishlist.textContent = copy.wishlist;
    replaceTitle(wishlistLink, 'Wishlist', copy.wishlist);

    var cartLink = toolbar.querySelector('[data-cart-sidebar]');
    var cart = cartLink && cartLink.querySelector('.toolbar-label');
    if (cart) cart.textContent = copy.cart;
    replaceTitle(cartLink, 'Cart', copy.cart);
  }

  function normalizedText(element) {
    return (element && element.textContent ? element.textContent : '')
      .replace(/\s+/g, ' ')
      .trim()
      .toUpperCase();
  }

  function rewriteMatchingLink(link, path) {
    if (!link || !path) return;
    link.setAttribute('href', localizedPath(path));
  }

  function rewriteLinksByText(container, textMap) {
    if (!container) return;
    container.querySelectorAll('a').forEach(function (link) {
      var text = normalizedText(link);
      Object.keys(textMap).some(function (label) {
        if (text === label || text.indexOf(label) !== -1) {
          rewriteMatchingLink(link, textMap[label]);
          return true;
        }
        return false;
      });
    });
  }

  function fixHomepageLinks() {
    if (!document.body.classList.contains('template-index')) return;

    var hero = document.querySelector('[id*="slideshow_tyrRgz"]');
    rewriteLinksByText(hero, {
      'SCOPRI LE CARTE SINGOLE': 'collections/carte-singole',
      'DISCOVER SINGLE CARDS': 'collections/carte-singole',
      'DÉCOUVRE LES CARTES À L’UNITÉ': 'collections/carte-singole',
      'EINZELKARTEN ENTDECKEN': 'collections/carte-singole',
      'DESCUBRE LAS CARTAS SUELTAS': 'collections/carte-singole',
      'PRODOTTI SIGILLATI': 'collections/prodotti-sigillati',
      'SEALED PRODUCTS': 'collections/prodotti-sigillati',
      'PRODUITS SCELLÉS': 'collections/prodotti-sigillati',
      'VERSIEGELTE PRODUKTE': 'collections/prodotti-sigillati',
      'PRODUCTOS SELLADOS': 'collections/prodotti-sigillati'
    });

    var explore = document.querySelector('[id*="collection_list_NRwJx3"]');
    rewriteLinksByText(explore, {
      'CARTE SINGOLE': 'collections/carte-singole',
      'SINGLE CARDS': 'collections/carte-singole',
      'CARTES À L’UNITÉ': 'collections/carte-singole',
      'EINZELKARTEN': 'collections/carte-singole',
      'CARTAS SUELTAS': 'collections/carte-singole',
      'PRODOTTI SIGILLATI': 'collections/prodotti-sigillati',
      'SEALED PRODUCTS': 'collections/prodotti-sigillati',
      'PRODUITS SCELLÉS': 'collections/prodotti-sigillati',
      'VERSIEGELTE PRODUKTE': 'collections/prodotti-sigillati',
      'PRODUCTOS SELLADOS': 'collections/prodotti-sigillati',
      'ACCESSORI TCG': 'collections/accessori-tcg',
      'TCG ACCESSORIES': 'collections/accessori-tcg',
      'ACCESSOIRES TCG': 'collections/accessori-tcg',
      'TCG-ZUBEHÖR': 'collections/accessori-tcg',
      'ACCESORIOS TCG': 'collections/accessori-tcg'
    });

    var games = document.querySelector('[id*="collection_list_BW6U6D"]');
    rewriteLinksByText(games, {
      'POKÉMON': 'pages/pokemon-tcg',
      'POKEMON': 'pages/pokemon-tcg',
      'MAGIC: THE GATHERING': 'pages/magic-the-gathering',
      'ONE PIECE': 'pages/one-piece-card-game',
      'RIFTBOUND': 'pages/riftbound-tcg',
      'DRAGON BALL': 'pages/dragon-ball-super-card-game',
      'FINAL FANTASY': 'pages/final-fantasy-tcg',
      'DISNEY LORCANA': 'pages/disney-lorcana-tcg',
      'LORCANA': 'pages/disney-lorcana-tcg',
      'STAR WARS UNLIMITED': 'pages/star-wars-unlimited',
      'DIGIMON': 'pages/digimon-card-game',
      'YU-GI-OH!': 'pages/yu-gi-oh',
      'YU-GI-OH': 'pages/yu-gi-oh'
    });
  }

  function run() {
    localizeInternalLinks();
    translateToolbar();
    fixHomepageLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
})();